import { useConfig } from "@/context/ConfigContext";
import { isSolanaEcosystemEnabled } from "@/lib/solanaFlags";
import SolanaEcosystemPage from "@/pages/SolanaEcosystemPage";
import NotFoundPage from "@/pages/NotFoundPage";

/** Route gate: backend /api/config flag is authoritative when present. */
export default function SolanaEcosystemGate() {
  const config = useConfig();
  if (config == null) {
    return <div className="min-h-screen bg-black" data-testid="sol-ecosystem-loading" aria-hidden />;
  }
  if (!isSolanaEcosystemEnabled(config)) {
    return <NotFoundPage title="Solana ecosystem unavailable" />;
  }
  return <SolanaEcosystemPage />;
}
